<template lang="jade">
  header#top
    h1
      a(v-link="{ path: '/' }") {{ title }} /
      a(v-link="{ path: '/photos' }")  PHOTOS
  router-view
</template>

<script>
  export default {
    data () {
      return {
        title: 'SHASTA'
      }
    }
  }
</script>

<style lang="sass?indentedSyntax">
  
  @import "../_sass/utilities/_utilities.sass"

  header
    position: fixed
    width: 100vw
    text-align: center
    z-index: 10
    padding: 3rem 1rem 0
    z-index: 12000

</style>


/** WEBPACK FOOTER **
 ** Shell.vue?270100c3
 **/